import * as types from './action-types';
import { range, find, pick } from 'lodash';
import { cellReducer, CellState } from './cell-reducer';

const CellsState = () => ({
  cells: range(0, Math.pow(2, 10)).map(i => cellReducer(CellState(i), {type: null, payload: null}))
});


export const VALID_CELL_PROPERTIES = [
  'name', 
  'birth', 
  'death', 
  'background', 
  'textColor', 
  'inverted', 
  'ascendancy', 
  'bandColor',
]

export function cellsReducer(state = CellsState(), {ascendancy, payload, type}) {
  switch (type) {
    case types.SET_NAME:
    case types.SET_BIRTH:
    case types.SET_DEATH:
    case types.SET_BACKGROUND:
    case types.SET_TEXT_COLOR:
    case types.SET_BAND_COLOR:
    case types.SET_PERSON_ID:
    case types.SET_INVERTED:
      return Object.assign({}, state, {
        cells: [
          ...state.cells.slice(0, ascendancy),
          cellReducer(state.cells[ascendancy], {payload, type}),
          ...state.cells.slice(ascendancy + 1),
        ]
      })
    case types.BATCH_UPDATE_CELLS:
      return Object.assign({}, state, {
        cells: state.cells.map(cell => ({
          ...cell,
          ...pick(find(payload, ({ascendancy}) => cell.ascendancy === ascendancy) || {}, VALID_CELL_PROPERTIES)
        }))
      })

    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/cells/reducer.js